// useWidth measures an element's box width and follows it as it changes, for
// anything drawn in pixels (an SVG chart) that must fill whatever column it is
// given rather than a viewBox scaled to fit.
import { useEffect, useRef, useState } from 'react'

export function useWidth<T extends HTMLElement>(fallback = 640) {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(fallback)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    setWidth(el.getBoundingClientRect().width || fallback)
    const ro = new ResizeObserver(([e]) => {
      if (e && e.contentRect.width > 0) setWidth(e.contentRect.width)
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [fallback])
  return { ref, width }
}
